import React, { useState, useEffect, useCallback } from 'react';
import { Container, Form, Modal, Button } from 'react-bootstrap'; // Ajout Modal et Button
import Navigation from '../components/Navbar';
import MovieCard from '../components/MovieCard';
import api from '../api';

const Home = () => {
    const [movies, setMovies] = useState([]);
    const [search, setSearch] = useState('');
    
    // États pour la modification
    const [showEdit, setShowEdit] = useState(false);
    const [selectedMovie, setSelectedMovie] = useState(null);

    const fetchMovies = useCallback(async () => {
        try {
            const res = await api.get(`/movies?search=${search}`);
            setMovies(res.data);
        } catch (err) { 
            console.error("Erreur lors de la récupération des films:", err); 
        }
    }, [search]);

    useEffect(() => { 
        fetchMovies(); 
    }, [fetchMovies]);

    const handleDelete = async (id) => {
        if (window.confirm("Supprimer ce film ?")) {
            try {
                await api.delete(`/movies/${id}`);
                fetchMovies();
            } catch (err) {
                console.error("Erreur lors de la suppression:", err);
            }
        }
    };

    // Ouvrir la modal de modification
    const handleEditClick = (movie) => {
        setSelectedMovie(movie);
        setShowEdit(true);
    };

    // Sauvegarder les modifs
    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            await api.put(`/movies/${selectedMovie.id}`, selectedMovie);
            setShowEdit(false);
            fetchMovies();
        } catch (err) {
            console.error("Erreur update:", err);
        }
    };

    return (
    <div className="min-vh-100 pb-5">
        <Navigation />
        <Container fluid className="px-lg-5 mt-4">
            <div className="d-flex justify-content-between align-items-center mb-5">
                <h2 className="fw-bold m-0">Ma Bibliothèque</h2>
                <Form.Control 
                    type="text" 
                    placeholder="Titre, genre..." 
                    className="search-bar-custom w-25 rounded-0"
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            {movies.length > 0 && (
                <>
                    <h5 className="text-muted mb-3">Dernières pépites</h5>
                    <div className="movie-grid mb-5">
                        {movies.slice(0, 6).map(movie => (
                            <MovieCard key={movie.id} movie={movie} onDelete={handleDelete} onEdit={handleEditClick} />
                        ))}
                    </div>
                </>
            )}

            <h5 className="text-muted mb-3">Tous les films</h5>
            <div className="movie-grid">
                {movies.map(movie => (
                    <MovieCard key={movie.id} movie={movie} onDelete={handleDelete} onEdit={handleEditClick} />
                ))}
            </div>

            {movies.length === 0 && <div className="text-center text-muted mt-5">Aucun film trouvé.</div>}
        </Container>

        {/* Modal de Modification */}
        <Modal show={showEdit} onHide={() => setShowEdit(false)} centered contentClassName="bg-dark text-white border-secondary">
            <Modal.Header closeButton closeVariant="white" className="border-secondary">
                <Modal.Title>Modifier les infos</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleUpdate}>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Titre</Form.Label>
                        <Form.Control 
                            className="bg-dark text-white border-secondary"
                            value={selectedMovie?.title || ''} 
                            onChange={e => setSelectedMovie({...selectedMovie, title: e.target.value})}
                        />
                    </Form.Group>

                    {/* AJOUT DU CHAMP DESCRIPTION */}
                    <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control 
                            as="textarea"
                            rows={3}
                            className="bg-dark text-white border-secondary"
                            value={selectedMovie?.description || ''} 
                            onChange={e => setSelectedMovie({...selectedMovie, description: e.target.value})}
                        />
                    </Form.Group>

                    <div className="d-flex gap-2">
                        <Form.Group className="mb-3 flex-grow-1">
                            <Form.Label>Genre</Form.Label>
                            <Form.Control 
                                className="bg-dark text-white border-secondary"
                                value={selectedMovie?.genre || ''} 
                                onChange={e => setSelectedMovie({...selectedMovie, genre: e.target.value})}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Année</Form.Label>
                            <Form.Control 
                                type="number"
                                className="bg-dark text-white border-secondary"
                                value={selectedMovie?.release_year || ''} 
                                onChange={e => setSelectedMovie({...selectedMovie, release_year: e.target.value})}
                            />
                        </Form.Group>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-secondary">
                    <Button variant="secondary" onClick={() => setShowEdit(false)}>Annuler</Button>
                    <Button variant="danger" type="submit">Sauvegarder</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    </div>
);
};

export default Home;